
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","viewBox":"0 0 22 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.1665 15.3115V16.4057","stroke":"white","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M8.8335 15.3115V16.4057","stroke":"white","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M19.6667 11.0001H2.33333C1.73533 11.0001 1.25 10.5147 1.25 9.91675V7.75008C1.25 7.15208 1.73533 6.66675 2.33333 6.66675H19.6667C20.2647 6.66675 20.75 7.15208 20.75 7.75008V9.91675C20.75 10.5147 20.2647 11.0001 19.6667 11.0001Z","stroke":"white","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M13.21 1.28247L16.4166 6.63414","stroke":"white","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M8.79016 1.28247L5.5835 6.63414","stroke":"white","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M19.4047 11L17.5771 19.4381C17.4157 20.1856 16.7538 20.7186 15.9889 20.7186H6.01145C5.24662 20.7186 4.58579 20.1856 4.42329 19.4381L2.5957 11","stroke":"white","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    